import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { SxProps, Theme } from "@mui/material/styles";

export const HIDDEN_VISIT_NOTE_TITLE = "Visit note hidden";
export const HIDDEN_VISIT_NOTE_MESSAGE =
  "This visit has a note, but only audiologists and business owners can view visit notes.";

type HiddenVisitNotePlaceholderProps = {
  title?: string;
  message?: string;
  sx?: SxProps<Theme>;
};

// ENG-2484: shown wherever a visit note would be for someone who may not see it. Says a note exists,
// so nobody tries to write a second one for the same visit.
export default function HiddenVisitNotePlaceholder({
  title = HIDDEN_VISIT_NOTE_TITLE,
  message = HIDDEN_VISIT_NOTE_MESSAGE,
  sx
}: HiddenVisitNotePlaceholderProps) {
  return (
    <Alert
      severity="info"
      icon={<LockOutlinedIcon fontSize="inherit" />}
      data-testid="hidden-visit-note-placeholder"
      sx={sx}
    >
      <AlertTitle>{title}</AlertTitle>
      {message}
    </Alert>
  );
}
